
import React from "react";
import CourseProgress from "./CourseProgress";
import LessonPrompt from "./LessonPrompt";
import EnrolledLessonView from "./EnrolledLessonView";

interface LessonType {
  id: string;
  title: string;
  duration: string;
  video_id: string;
  pdf_url?: string;
  isCompleted: boolean;
  description?: string;
}

interface ModuleType {
  id: string;
  title: string;
  lessons: LessonType[];
}

interface EnrolledViewProps {
  courseId: string;
  course: {
    title: string;
    image_url: string;
  };
  modulesList: ModuleType[];
  activeVideoId: string | null;
  activePdfUrl: string | null;
  userProgress: number;
  onLessonSelect: (lesson: LessonType) => void;
  onLessonComplete: () => Promise<any>;
  onVideoEnd: () => Promise<any>;
  activeLesson: LessonType | null;
  userCourse: any;
  setUserCourse: (userCourse: any) => void;
}

const EnrolledView = ({ 
  courseId, 
  course, 
  modulesList, 
  activeVideoId, 
  activePdfUrl,
  userProgress, 
  onLessonSelect,
  onLessonComplete,
  onVideoEnd,
  activeLesson,
  userCourse,
  setUserCourse
}: EnrolledViewProps) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2">
        {activeLesson ? (
          <EnrolledLessonView
            activeLesson={activeLesson}
            modulesList={modulesList}
            userCourse={userCourse}
            onLessonSelect={onLessonSelect}
            onLessonComplete={onLessonComplete}
            onVideoEnd={onVideoEnd}
            courseImage={course.image_url}
          />
        ) : (
          <LessonPrompt />
        )}
      </div>
      
      <div className="lg:col-span-1">
        <CourseProgress 
          modulesList={modulesList}
          courseId={courseId}
          activeVideoId={activeVideoId}
          userProgress={userProgress}
          onLessonSelect={onLessonSelect}
        />
      </div>
    </div>
  );
};

export default EnrolledView;
